module.exports = __webpack_public_path__ + "static/media/telegram.dd19c3d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/telegram.svg
// module id = 781
// module chunks = 0